import { LogoutButton } from "@/components/UserNav/LogoutButton";
import { LoadingState } from "@/components/UserNav/LoadingState";
import { useAuth } from "@/contexts/AuthContext";
import { UserInfo } from "@/components/UserNav/UserInfo";
import { TutorialButton } from "@/components/tutorial/TutorialButton";

export const UserNav = () => {
    const { user, loading, signOut } = useAuth();

    if (loading) {
        return <LoadingState />;
    }

    if (!user) {
        return null;
    }

    return (
        <div className="flex items-center gap-4">
            <TutorialButton />
            <UserInfo user={user} />
            <LogoutButton onLogout={signOut} />
        </div>
    );
};